var map = {
	"./1INCH.svg": 15840,
	"./1ST.svg": 86776,
	"./2GIVE.svg": 13236,
	"./2KEY.svg": 5988,
	"./ABBC.svg": 80480,
	"./ABT.svg": 19704,
	"./ACT.svg": 98116,
	"./ADA.svg": 86572,
	"./ADK.svg": 30740,
	"./ADT.svg": 25780,
	"./ADX.svg": 22704,
	"./AE.svg": 34932,
	"./AEON.svg": 18004,
	"./AGI.svg": 99776,
	"./AGRS.svg": 16528,
	"./AID.svg": 27532,
	"./AION.svg": 15092,
	"./AKRO.svg": 40752,
	"./ALGO.svg": 2830,
	"./AMB.svg": 53264,
	"./AMP.svg": 31056,
	"./AMPL.svg": 21500,
	"./ANT.svg": 23764,
	"./AOA.svg": 14392,
	"./APL.svg": 77508,
	"./APPC.svg": 50460,
	"./APX.svg": 42472,
	"./ARDR.svg": 63612,
	"./ARK.svg": 68636,
	"./ARN.svg": 3108,
	"./ARPA.svg": 5548,
	"./ARRR.svg": 1368,
	"./AST.svg": 10004,
	"./ATM.svg": 54616,
	"./ATOM.svg": 53940,
	"./AUR.svg": 1424,
	"./AUTO.svg": 87244,
	"./BAL.png": 52212,
	"./BAL.svg": 73016,
	"./BAND.png": 80661,
	"./BAND.svg": 86480,
	"./BAT.png": 32199,
	"./BAT.svg": 57340,
	"./BAY.png": 14552,
	"./BAY.svg": 28208,
	"./BBK.png": 43772,
	"./BBK.svg": 26068,
	"./BCC.png": 71616,
	"./BCC.svg": 15916,
	"./BCD.png": 56852,
	"./BCD.svg": 10488,
	"./BCH.png": 97716,
	"./BCH.svg": 29376,
	"./BCN.png": 47752,
	"./BCN.svg": 69460,
	"./BCPT.png": 46960,
	"./BCPT.svg": 38356,
	"./BCY.png": 11128,
	"./BCY.svg": 76924,
	"./BEAM.png": 17344,
	"./BEAM.svg": 92276,
	"./BELA.png": 82300,
	"./BELA.svg": 60048,
	"./BF.png": 2672,
	"./BF.svg": 58508,
	"./BITB.png": 60324,
	"./BITB.svg": 29444,
	"./BITCNY.png": 77324,
	"./BITCNY.svg": 4212,
	"./BITS.png": 42700,
	"./BITS.svg": 92572,
	"./BIX.png": 52072,
	"./BIX.svg": 37952,
	"./BKX.png": 2060,
	"./BKX.svg": 30772,
	"./BLITZ.png": 68024,
	"./BLITZ.svg": 36759,
	"./BLK.png": 76532,
	"./BLK.svg": 40476,
	"./BLOCK.png": 81404,
	"./BLOCK.svg": 72016,
	"./BLT.png": 964,
	"./BLT.svg": 47788,
	"./BLZ.png": 6740,
	"./BLZ.svg": 75196,
	"./BMC.png": 52976,
	"./BMC.svg": 98276,
	"./BNB.png": 72808,
	"./BNB.svg": 69208,
	"./BNK.png": 82660,
	"./BNK.svg": 52956,
	"./BNT.png": 47152,
	"./BNT.svg": 63800,
	"./BOS.png": 88848,
	"./BOS.svg": 67344,
	"./BPT.png": 73503,
	"./BPT.svg": 68784,
	"./BRD.png": 40164,
	"./BRD.svg": 81208,
	"./BRK.png": 6284,
	"./BRK.svg": 10900,
	"./BRX.png": 12552,
	"./BRX.svg": 67496,
	"./BSD.png": 78180,
	"./BSD.svg": 42736,
	"./BST.png": 35732,
	"./BST.svg": 66212,
	"./BSV.png": 74012,
	"./BSV.svg": 65532,
	"./BTC-disabled.svg": 75192,
	"./BTC.png": 18588,
	"./BTC.svg": 78956,
	"./BTCP.png": 36524,
	"./BTCP.svg": 44624,
	"./BTCZ.png": 74375,
	"./BTCZ.svg": 7728,
	"./BTDX.png": 17920,
	"./BTDX.svg": 51276,
	"./BTG.png": 55760,
	"./BTG.svg": 88612,
	"./BTM.png": 89580,
	"./BTM.svg": 60704,
	"./BTO.png": 11108,
	"./BTO.svg": 64260,
	"./BTS.png": 32708,
	"./BTS.svg": 28376,
	"./BTT.png": 72439,
	"./BTT.svg": 40936,
	"./BTX.png": 64508,
	"./BTX.svg": 43216,
	"./BURST.png": 53924,
	"./BURST.svg": 13264,
	"./BXX.png": 98756,
	"./BXX.svg": 69964,
	"./BYC.png": 89856,
	"./BYC.svg": 46880,
	"./BZRX.png": 9956,
	"./BZRX.svg": 33268,
	"./CAT.svg": 25424,
	"./CBC.svg": 47180,
	"./CDT.svg": 30412,
	"./CEL.svg": 70184,
	"./CELO.svg": 66112,
	"./CENNZ.svg": 41242,
	"./CFI.svg": 7288,
	"./CHAT.svg": 98560,
	"./CHCB.svg": 47820,
	"./CHZ.svg": 3169,
	"./CKB.svg": 50612,
	"./CLAM.svg": 74172,
	"./CLOAK.svg": 51376,
	"./CLUB.svg": 95160,
	"./CMCT.svg": 14693,
	"./CMM.svg": 14075,
	"./CMT.svg": 85724,
	"./CND.svg": 52060,
	"./CNX.svg": 20212,
	"./COB.svg": 556,
	"./COLX.svg": 22088,
	"./COMP.svg": 11260,
	"./COTI.svg": 31212,
	"./COVAL.svg": 24464,
	"./CPC.svg": 98864,
	"./CRB.svg": 34876,
	"./CREAM.svg": 48576,
	"./CRED.svg": 24076,
	"./CRO.svg": 21364,
	"./CRV.svg": 37652,
	"./CRW.svg": 78632,
	"./CS.svg": 15384,
	"./CTXC.svg": 77632,
	"./CVC.svg": 68528,
	"./CVT.svg": 15432,
	"./Cusd.svg": 22608,
	"./DAI.svg": 81116,
	"./DASH.svg": 44296,
	"./DAT.svg": 12300,
	"./DATA.svg": 46280,
	"./DBC.svg": 38159,
	"./DCN.svg": 32628,
	"./DCR.svg": 50376,
	"./DCT.svg": 71016,
	"./DDJ.svg": 97752,
	"./DENT.svg": 46348,
	"./DFI.svg": 9036,
	"./DGB.svg": 19908,
	"./DGD.svg": 96352,
	"./DIVI.svg": 91428,
	"./DLT.svg": 9660,
	"./DMD.svg": 46052,
	"./DMT.svg": 36152,
	"./DNT.svg": 71255,
	"./DOCK-1.svg": 6324,
	"./DOCK.svg": 43400,
	"./DOGE.svg": 228,
	"./DOT.svg": 2084,
	"./DRG.svg": 65087,
	"./DROP.svg": 13344,
	"./DRT.svg": 99700,
	"./DTA.svg": 76375,
	"./DTH.svg": 37888,
	"./DTR.svg": 69700,
	"./DYN.svg": 72448,
	"./EBST.svg": 70423,
	"./ECA.svg": 28348,
	"./EDG.svg": 60948,
	"./EFL.svg": 99324,
	"./EGC.svg": 55260,
	"./EGT.svg": 13160,
	"./EKT.svg": 52532,
	"./ELA.svg": 80364,
	"./ELF.svg": 14884,
	"./ELLA.svg": 99256,
	"./EMC.svg": 364,
	"./EMC2.svg": 90680,
	"./ENG.svg": 25320,
	"./ENJ.svg": 82232,
	"./ENRG.svg": 56356,
	"./EOS.svg": 51824,
	"./ERC.svg": 38292,
	"./ESBC.svg": 42420,
	"./ETC.svg": 74072,
	"./ETH.svg": 59556,
	"./ETN.svg": 55800,
	"./ETP.svg": 77148,
	"./ETZ.svg": 93668,
	"./EUR.png": 30884,
	"./EUR.svg": 56932,
	"./EUROC.svg": 59196,
	"./EURS.svg": 3544,
	"./EURT.svg": 18788,
	"./EVX.svg": 9852,
	"./EXCL.svg": 84256,
	"./EXP.svg": 4816,
	"./FACE.svg": 82848,
	"./FAIR.svg": 4424,
	"./FCT.svg": 23324,
	"./FET.svg": 66068,
	"./FIL.svg": 82964,
	"./FJC.svg": 84572,
	"./FLDC.svg": 51444,
	"./FLO.svg": 35568,
	"./FOAM.svg": 35372,
	"./FSN.svg": 45924,
	"./FTC.svg": 44648,
	"./FTM.svg": 78376,
	"./FTT.svg": 99924,
	"./FUEL.svg": 11612,
	"./FUN.svg": 41860,
	"./FXC.svg": 35284,
	"./GAM.svg": 91632,
	"./GAME.svg": 63564,
	"./GAS.svg": 69016,
	"./GBP.png": 65968,
	"./GBP.svg": 74763,
	"./GBX-1.svg": 87020,
	"./GBX.svg": 32388,
	"./GBYTE.svg": 19268,
	"./GCR.svg": 27424,
	"./GEO.svg": 53088,
	"./GLD.svg": 59872,
	"./GNO.svg": 4300,
	"./GNT.svg": 74156,
	"./GOLOS.svg": 21240,
	"./GRC.svg": 79692,
	"./GRIN.svg": 69615,
	"./GRS.svg": 96604,
	"./GSC.svg": 86068,
	"./GTO.svg": 14236,
	"./GUP.svg": 19204,
	"./GUSD.svg": 59880,
	"./GVT.svg": 2940,
	"./GXC.svg": 58759,
	"./HBAR.svg": 82576,
	"./HC.svg": 32020,
	"./HEDG.svg": 24421,
	"./HEX.svg": 98548,
	"./HIVE.svg": 69792,
	"./HMQ.svg": 9752,
	"./HNS.svg": 1980,
	"./HOT.svg": 96720,
	"./HPB.svg": 20031,
	"./HT.svg": 13233,
	"./HTML.svg": 23571,
	"./HUSD.svg": 24564,
	"./HUSH.svg": 44804,
	"./HYDRO.svg": 58124,
	"./ICX.svg": 69450,
	"./IDEX.svg": 33527,
	"./IGNIS.svg": 68624,
	"./INB.svg": 7324,
	"./INCNT.svg": 82132,
	"./INFX.svg": 95668,
	"./INK.svg": 82460,
	"./IOC.svg": 63512,
	"./ION.svg": 38948,
	"./IOP.svg": 78392,
	"./IOST.svg": 18644,
	"./IOT.svg": 87200,
	"./IOTX.svg": 62196,
	"./IQ.svg": 89056,
	"./IQN.svg": 37104,
	"./IRIS.svg": 55792,
	"./ITC.svg": 62504,
	"./JNT.svg": 41808,
	"./JST.svg": 76976,
	"./KARMA.svg": 46592,
	"./KAT.svg": 95208,
	"./KAVA.svg": 77476,
	"./KBC.svg": 15852,
	"./KCS.svg": 2092,
	"./KIN.svg": 81324,
	"./KMD.svg": 9772,
	"./KNC.svg": 52780,
	"./KNDC.svg": 63748,
	"./KORE.svg": 56548,
	"./KRB.svg": 32276,
	"./KSM.svg": 16208,
	"./LA.svg": 64396,
	"./LBC.svg": 81428,
	"./LCC.svg": 53944,
	"./LEND.svg": 88364,
	"./LEO.svg": 81732,
	"./LIKE.svg": 80128,
	"./LINK.svg": 61908,
	"./LKK.svg": 78680,
	"./LMC.svg": 65332,
	"./LOKI.svg": 46808,
	"./LOOM.svg": 25880,
	"./LPT.svg": 43288,
	"./LRC-1.svg": 58628,
	"./LRC.svg": 10084,
	"./LSK.svg": 9180,
	"./LTC.svg": 79668,
	"./LTO.svg": 88324,
	"./LUN.svg": 94708,
	"./LYM.svg": 19440,
	"./MAID.svg": 90378,
	"./MANA.svg": 67204,
	"./MATIC.svg": 1572,
	"./MB.svg": 68252,
	"./MCO.svg": 83292,
	"./MDA.svg": 69844,
	"./MDS.svg": 51408,
	"./MED.svg": 16348,
	"./MEETONE.svg": 67464,
	"./MER.svg": 50060,
	"./META.svg": 77404,
	"./MFT.svg": 28912,
	"./MIOTA.svg": 4168,
	"./MITH.svg": 56928,
	"./MKR.svg": 17620,
	"./MLN.svg": 43484,
	"./MNS.svg": 43188,
	"./MOAC.svg": 20508,
	"./MOF.svg": 89548,
	"./MONA.svg": 95596,
	"./MOON.svg": 11104,
	"./MSR.svg": 64640,
	"./MTH.svg": 93879,
	"./MTL.svg": 15216,
	"./MUE.svg": 43784,
	"./MUSIC.svg": 28336,
	"./MXC.svg": 7600,
	"./MYST.svg": 69004,
	"./NANO.svg": 29108,
	"./NAS.svg": 92624,
	"./NAV.svg": 19483,
	"./NBT.svg": 19367,
	"./NCASH.svg": 44332,
	"./NCT.svg": 27240,
	"./NEBL.svg": 45260,
	"./NEO.svg": 92776,
	"./NEOS.svg": 77040,
	"./NEST.svg": 24896,
	"./NEU.svg": 83408,
	"./NEW.svg": 37416,
	"./NEXO.svg": 1092,
	"./NGC.svg": 34804,
	"./NIM.svg": 38132,
	"./NLC2.svg": 50816,
	"./NLG.svg": 7768,
	"./NMC.svg": 67724,
	"./NMR.svg": 80340,
	"./NPXS.svg": 69832,
	"./NULS.svg": 2132,
	"./NXS.svg": 7916,
	"./NXT.svg": 54132,
	"./OAX.svg": 58356,
	"./OCEAN.svg": 55812,
	"./OCN.svg": 54476,
	"./ODE.svg": 57362,
	"./OGN.svg": 30360,
	"./OK.svg": 95604,
	"./OKB.svg": 46461,
	"./OMG.svg": 15120,
	"./OMNI.svg": 94836,
	"./ONE.svg": 49556,
	"./ONG.svg": 50296,
	"./ONT.svg": 65936,
	"./OOT.svg": 25928,
	"./ORBS.svg": 89668,
	"./OST.svg": 34444,
	"./OURO.svg": 57632,
	"./OXT.svg": 37272,
	"./PART.svg": 41988,
	"./PASC.svg": 82064,
	"./PAX.svg": 15912,
	"./PAXG.svg": 34632,
	"./PAY.svg": 81044,
	"./PAYX.svg": 42116,
	"./PCX.svg": 69644,
	"./PEARL.svg": 92328,
	"./PERL.svg": 34668,
	"./PINK.svg": 71120,
	"./PIRL.svg": 47274,
	"./PIVX.svg": 65364,
	"./PKB.svg": 10311,
	"./PLBT.svg": 34452,
	"./PLR.svg": 39580,
	"./PLU.svg": 95328,
	"./PMA.svg": 83012,
	"./POE.svg": 70828,
	"./POLIS.svg": 35580,
	"./POLY.svg": 58128,
	"./POT.svg": 94372,
	"./POWER.svg": 45892,
	"./PPC.svg": 73444,
	"./PPP.svg": 17488,
	"./PPT.svg": 99876,
	"./PRE.svg": 12020,
	"./PRO.svg": 29160,
	"./PTC.svg": 56956,
	"./PTOY.svg": 67844,
	"./QASH.svg": 43756,
	"./QKC.svg": 4500,
	"./QLC.svg": 75716,
	"./QNT.svg": 11781,
	"./QRL.svg": 92312,
	"./QSP.svg": 34468,
	"./QTUM.svg": 15572,
	"./QUN.svg": 75664,
	"./QWARK.svg": 29736,
	"./RADS.svg": 20888,
	"./RBY.svg": 90728,
	"./RCN.svg": 18492,
	"./RDD.svg": 47100,
	"./RDN.svg": 50152,
	"./REN.svg": 87948,
	"./REP-1.svg": 94240,
	"./REP.svg": 87228,
	"./REQ.svg": 59636,
	"./RIF.svg": 61012,
	"./RISE.svg": 45612,
	"./RLC.svg": 78228,
	"./RSR.svg": 88196,
	"./RUFF.svg": 96332,
	"./RUNE.svg": 4784,
	"./RVN.svg": 37169,
	"./RVR.svg": 4460,
	"./RYO.svg": 86844,
	"./SAFEX.svg": 86760,
	"./SALT.svg": 8048,
	"./SAN.svg": 54752,
	"./SBD.svg": 90348,
	"./SC.svg": 86488,
	"./SEELE.svg": 99196,
	"./SEQ.svg": 98641,
	"./SHIFT.svg": 57472,
	"./SHIP.svg": 84468,
	"./SIB.svg": 22952,
	"./SKY.svg": 34551,
	"./SLR.svg": 12568,
	"./SLS.svg": 59532,
	"./SMART.svg": 45216,
	"./SNGLS.svg": 5088,
	"./SNM.svg": 85196,
	"./SNT.svg": 11220,
	"./SNX.svg": 37116,
	"./SOC.svg": 52964,
	"./SOL.svg": 25420,
	"./SPANK.svg": 48528,
	"./SPHR.svg": 6928,
	"./SPHTX.svg": 54096,
	"./SPR.svg": 48768,
	"./SRM.svg": 18920,
	"./SRN.svg": 5248,
	"./STAK.svg": 77984,
	"./STAKE.svg": 83576,
	"./STAKING.svg": 36016,
	"./START.svg": 6720,
	"./STEEM.svg": 27924,
	"./STORJ.svg": 72668,
	"./STORM.svg": 46160,
	"./STQ.svg": 53571,
	"./STRAT.svg": 38944,
	"./STRONG.svg": 85084,
	"./STX.svg": 27072,
	"./SUB.svg": 65444,
	"./SUMO.svg": 27764,
	"./SUTER.svg": 6040,
	"./SWT.svg": 47512,
	"./SWTH.svg": 23815,
	"./SXP.svg": 27620,
	"./SYNX.svg": 86452,
	"./SYS.svg": 56452,
	"./TAAS.svg": 11880,
	"./TAU.svg": 47452,
	"./TBX.svg": 40064,
	"./TCH.svg": 22528,
	"./TEL.svg": 74932,
	"./TEN.svg": 39020,
	"./TERA.svg": 96740,
	"./TERN.svg": 40248,
	"./THC.svg": 40692,
	"./THETA.svg": 32268,
	"./THR.svg": 44836,
	"./TIME.svg": 3608,
	"./TIX.svg": 91436,
	"./TKN.svg": 87628,
	"./TKS.svg": 65612,
	"./TNB.svg": 17208,
	"./TNC.svg": 64172,
	"./TNT.svg": 46343,
	"./TOMO.svg": 79647,
	"./TOR.svg": 6940,
	"./TPAY.svg": 99432,
	"./TRB.svg": 86312,
	"./TRIG.svg": 85204,
	"./TRST.svg": 22492,
	"./TRTL.svg": 99080,
	"./TRX.svg": 87120,
	"./TUBE.svg": 13240,
	"./TUSD.svg": 5108,
	"./TX.svg": 85340,
	"./TZC.svg": 51800,
	"./UBQ.svg": 52492,
	"./UKG.svg": 65356,
	"./UMA.svg": 43839,
	"./UNB.svg": 59304,
	"./UNI.svg": 87736,
	"./UP.svg": 44140,
	"./USD.png": 23796,
	"./USD.svg": 52720,
	"./USDC-disabled.svg": 69076,
	"./USDC.svg": 65236,
	"./USDT.svg": 15468,
	"./UTK.svg": 15032,
	"./VEE.svg": 6728,
	"./VEIL.svg": 77328,
	"./VEN.svg": 8812,
	"./VERI.svg": 29832,
	"./VET.svg": 79716,
	"./VIA.svg": 11448,
	"./VIB.svg": 96184,
	"./VIBE.svg": 84632,
	"./VITE.svg": 61884,
	"./VRC.svg": 20556,
	"./VRM.svg": 69892,
	"./VSYS.svg": 58016,
	"./VTC.svg": 59735,
	"./VTHO.svg": 7172,
	"./VTR.svg": 36660,
	"./WABI.svg": 1732,
	"./WAN.svg": 45500,
	"./WAVES.svg": 20348,
	"./WAX.svg": 78364,
	"./WBTC.svg": 28812,
	"./WGR.svg": 72900,
	"./WICC.svg": 97316,
	"./WINGS.svg": 25100,
	"./WPR.svg": 49060,
	"./WTC.svg": 39764,
	"./XAS.svg": 27732,
	"./XAUT.svg": 82780,
	"./XBC.svg": 11980,
	"./XBY.svg": 17992,
	"./XCP.svg": 31232,
	"./XDN.svg": 12076,
	"./XEL.svg": 15172,
	"./XEM.svg": 76964,
	"./XIN.svg": 11492,
	"./XLM.svg": 52348,
	"./XMG.svg": 38604,
	"./XMR.svg": 84668,
	"./XMX.svg": 31548,
	"./XMY.svg": 38420,
	"./XNS.svg": 54073,
	"./XOR.svg": 11276,
	"./XP.svg": 29136,
	"./XPA.svg": 9196,
	"./XPM.svg": 26732,
	"./XPR.svg": 74260,
	"./XRP.svg": 97588,
	"./XSG.svg": 10983,
	"./XSR.svg": 58428,
	"./XST.svg": 53820,
	"./XTP.svg": 27076,
	"./XTZ.svg": 45732,
	"./XUC.svg": 67960,
	"./XVC.svg": 61696,
	"./XVG.svg": 36480,
	"./XWC.svg": 74492,
	"./XZC.svg": 24432,
	"./YFI-1.svg": 25388,
	"./YFI.svg": 99304,
	"./YOYOW-1.svg": 80904,
	"./YOYOW.svg": 45895,
	"./ZAR.svg": 46992,
	"./ZB.svg": 63796,
	"./ZCL.svg": 85912,
	"./ZEC.svg": 87248,
	"./ZEL.svg": 18796,
	"./ZEN.svg": 17657,
	"./ZIL.svg": 50820,
	"./ZIP.svg": 53408,
	"./ZRX.svg": 8456,
	"./arrow-down.svg": 48567,
	"./calendar.svg": 31728,
	"./cashback.svg": 14016,
	"./cryptodraft.svg": 76548,
	"./doc.svg": 31376,
	"./document-other.svg": 36908,
	"./info.svg": 46964,
	"./jpg.svg": 90796,
	"./maxxwell.svg": 78264,
	"./minus.svg": 76928,
	"./new-check.svg": 11216,
	"./other.svg": 94644,
	"./pdf.svg": 79408,
	"./plus.svg": 50020,
	"./png.svg": 51855,
	"./telegram.svg": 38544,
	"./trash.svg": 31780,
	"./whatsapp.svg": 37220
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34640;